module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_8011.57eb0657.png";